<template>
    <div
        @focusin="onFocus"
        @focusout="onFocusout"
    >
        <show-all-new
            :title="pageTitle"
            :items="listItems"
            :is-loading="false"
            @item-selected="itemSelected"
        />
    </div>
</template>

<script lang="ts" setup>
    import { Strings } from '@/locales/types/enums';
    import { linkItems } from "@/components/Header/types/LinkItemsCollection";
    import { useI18n } from "vue-i18n";
    import { useRouter } from 'vue-router';
    import { useGenresStore } from "@/stores/Genres";
    import { storeToRefs } from 'pinia';
    import type { IEventSelected } from "@/components/MultiLineView/types";
    import type { GenreCardData } from "@/components/Cards/types";

    definePageMeta({ 
        layout: 'default-no-header',
        middleware: ['set-page-indicator', 'fetch-vod-show-all-channels'],
    });

    const GenresStore = useGenresStore();
    const {
        getAllGenres: listItems,
    } = storeToRefs(GenresStore);

    const { $navigator } = useNuxtApp();
    const router = useRouter();
    const { t } = useI18n();
    const pageTitle: string = t(Strings.VOD_CHANNELS).toString();

    const itemSelected = (event: IEventSelected): void => {
        if ((event.item as GenreCardData).getIsPremium()) {
            router.push(`${linkItems.subgenresPremium.routerPath}/${event.item.getId()}`);
            return;
        }
        router.push(`${linkItems.subgenres.routerPath}/${event.item.getId()}`);
    };

    const onFocus = () => {
        registerKeyListeners();
    };
    const onFocusout = () => {
        unregisterKeyListeners();
    };
    const keyBackListener = (): void => {
        router.go(-1);
    };
    const registerKeyListeners = (): void => {
        $navigator.on("keypress:back", keyBackListener);
    };
    const unregisterKeyListeners = (): void => {
        $navigator.off("keypress:back", keyBackListener);
    };
</script>
